import React, { Fragment, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import DataTable from "../../../../Common/Components/DataTable";
import Loading from "../../../../Common/Components/Loading";
import { useStatusAthelets } from "../Hooks";
import { Table } from "react-bootstrap";
import { Day, ToDateJalali } from "../../../../Common/Function";
const ActiveList = ({ isApp }) => {
  const { data, getListPA, loading, searchHandler, paginateActive } = useStatusAthelets();
  const navigate = useNavigate();

  useEffect(() => {
    getListPA();
  }, []);

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست حضور غیاب</title>
      </Helmet>

      <Fragment>

        {isApp && (
          loading.pa
            ? <Loading count={3} height={"40px"} col={"12"} />
            : <Table striped bordered hover className="mt-3">
              <thead className="mt-3 nfs-12 allCenter">
                <tr>
                  <th>شماره</th>
                  <th>روز هفته</th>
                  <th>تاریخ</th>
                  <th>ساعت</th>
                </tr>
              </thead>
              <tbody className="allCenter nfs-12">
                {data.pa_list.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{Day(item.dayname)}</td>
                    <td>{ToDateJalali(item.date)}</td>
                    <td>{item.time}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
        )}

        {!isApp && <DataTable
          loading={loading.pa}
          heads={[
            {
              title: "تاریخ",
              key: "date",
              type: "date",
              timetype: "date",
            },
            {
              title: "روز",
              key: "dayname",
              type: "dayname",
            },
            {
              title: "ساعت",
              key: "time",
            },
          ]}
          textEmpty="لیست حضور یافت نشد"
          list={data.pa_list}
          data={data}
          function={paginateActive}
          search={searchHandler}
          currentPage={data.current_page}
          header="لیست حضور غیاب"
        />
        }
      </Fragment>
    </Fragment>
  );
};

export default ActiveList;
